import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  if(key=='GetYesterdayBriefing'){
    url = '/h5/YesterdayBriefing/index'
  }
  if(key=='GetYesterdayShops'){
    url = '/h5/YesterdayBriefing/getBossShopList'
  }
  if(key=='YesterdayCustomer'){
    url = '/h5/YesterdayCustomer/index'
  }

  
  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}







export default QUERY;